module.exports = __webpack_public_path__ + "media/deutsche-bank.ca286ef1.mp4";